import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoafericao(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoafericao/FIND_OPERACAOAFERICAO':
      case '@operacaoafericao/UPDATE_OPERACAOAFERICAO':
      case '@operacaoafericao/DELETE_OPERACAOAFERICAO':
      case '@operacaoafericao/STORE_OPERACAOAFERICAO':
      case '@operacaoafericao/OPERACAOAFERICAO_IN_REQUEST': {
        draft.loading = true;
        draft.find = null;
        break;
      }

      case '@operacaoafericao/SUCCESS_REMOVE':
      case '@operacaoafericao/FAILED_REQUEST': {
        draft.loading = false;
        draft.find = null;
        break;
      }

      case '@operacaoafericao/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoafericao;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoafericao/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoafericao;
        break;
      }

      case '@operacaoafericao/RECORD_FILTERING': {
        draft.loading = true;
        draft.find = null;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
